import React from "react";
import { observer } from "mobx-react";

const fmtDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
};

const hostFromLink = (link) => {
  try { return new URL(link).hostname.replace(/^www\./, ""); }
  catch { return ""; }
};

const DeeperContext = observer(({ userInsights }) => {
  const posts = userInsights?.deeper_context?.notable_posts;
  if (!Array.isArray(posts) || posts.length === 0) return null;

  return (
    <div className="drSection drDeeper">
      <div className="drSectionHeader">
        <span className="drSectionIcon">📝</span>
        <h3>Notable Posts</h3>
      </div>
      <ul className="drDeeper__postsList">
        {posts.map((p, i) => (
          <li key={i} className="drDeeper__postsItem">
            <div className="drDeeper__postsMeta">
              {p.date && <span className="drDeeper__postsDate">{fmtDate(p.date)}</span>}
              {p.theme && <span className="drDeeper__postsTheme">{p.theme}</span>}
            </div>
            {p.summary && <div className="drDeeper__postsSummary">{p.summary}</div>}
            {p.link && (
              <a
                className="drDeeper__postsSource"
                href={p.link}
                target="_blank"
                rel="noopener noreferrer"
                title={p.link}
              >
                <i className="material-icons-outlined drDeeper__postsSourceIcon">link</i>
                {hostFromLink(p.link) || "Source"}
              </a>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
});

export default DeeperContext;
